import React, {Component} from 'react';
import './shopContactSalomCard.scss';
import OrderCard from '../../../shared/assets/images/partnerDetails/salom-card.png';
import AlifSalom from '../../../shared/assets/images/partnerDetails/salom-card-red.png';
import AlifShop from '../../../shared/assets/images/partnerDetails/alif-shop-card.png';
import {Link} from "react-scroll";

class ShopContactSalomCard extends Component {
    // eslint-disable-next-line no-useless-constructor
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="ShopContactSalomCard">
                <div className="container">
                    <div className="row ctm-row-two">
                        <span>
                            Как купить в рассрочку
                            {this.props.windowWidth > 768 ? <br/> : ' '}
                            без комиссии и предоплаты до 24 месяца
                        </span>
                    </div>
                    <div className="row ctm-row-three">
                        <div className="col-12 col-sm-8 col-md-6 col-lg-4 ctm-col-one">
                            <div className="ctm-container">
                                <div className="ctm-title">
                                    У меня нет карты «Салом» или лимита
                                </div>
                                <div className="ctm-img-container">
                                    <img src={OrderCard} alt="OrderCard"/>
                                    <Link
                                        to={"salomCardForm"}
                                        // hashSpy={true}
                                        // spy={true}
                                        smooth={true}
                                    >
                                        Заказать карту
                                    </Link>
                                </div>
                                <div className="ctm-text-one">
                                    Для совершения покупок картой, оставьте заявку заполнив форму.
                                </div>
                                <div className="ctm-text-two">
                                    Для увеличения лимита предоставьте справку о доходах, отправив на <a
                                    href="https://doc.alif.tj/">doc.alif.tj</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-8 col-md-6 col-lg-4 ctm-col-two">
                            <div className="ctm-container">
                                <div className="ctm-title">
                                    У меня есть карта «Салом» с лимитом
                                </div>
                                <div className="ctm-img-container">
                                    <img src={AlifSalom} alt="AlifSalom"/>
                                </div>
                                <div className="ctm-text-one">
                                    Подойдите с картой к партнёру, выберите товар или услугу и совершите покупку в
                                    течение 5
                                    минут.
                                </div>
                                <div className="ctm-text-two">
                                    Удачных покупок!
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-8 col-md-6 col-lg-4 ctm-col-three">
                            <div className="ctm-container">
                                <div className="ctm-title">
                                    У меня нет карты «Салом» и лимита
                                </div>
                                <div className="ctm-img-container">
                                    <img src={AlifShop} alt="AlifShop"/>
                                </div>
                                <div className="ctm-text-one">
                                    <div>
                                        1
                                    </div>
                                    <div>
                                        Зайдите на сайт <a href="https://alif.shop/">alifshop.tj</a>, выберите товар или
                                        услугу, оставьте заказ
                                    </div>
                                </div>
                                <div className="ctm-text-two">
                                    <div>
                                        2
                                    </div>
                                    <div>
                                        Отправьте ваш паспорт и справку о доходах, отправив на <a
                                        href="https://doc.alif.tj/">doc.alif.tj</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ShopContactSalomCard;